import { getErrorAction } from './errorMapper'
import { actions } from 'react-redux-toastr'
import uniqueId from 'lodash/uniqueId'
import { createReducer } from './reducerUtils'
import { mergeMap, map, catchError } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { of } from 'rxjs'

// Constants
export const GENERATED_TASK_ID_PREFIX = 'unsaved-task-'
export const isGeneratedId = (id) => id && id.slice(0, GENERATED_TASK_ID_PREFIX.length) === GENERATED_TASK_ID_PREFIX

// Actions
export const TASK_ADD_START = 'TASK_ADD_START'
export const TASK_ADD_CANCEL = 'TASK_ADD_CANCEL'
export const TASK_ADD_SAVE = 'TASK_ADD_SAVE'
export const TASK_ADD_SAVE_SUCCESS = 'TASK_ADD_SAVE_SUCCESS'
export const TASK_ADD_SAVE_FAILURE = 'TASK_ADD_SAVE_FAILURE'
export const TASK_ADD_SAVE_NOOP = 'TASK_ADD_SAVE_NOOP'

// Action creators
export const taskAddStart = () => ({ type: TASK_ADD_START })
export const taskAddCancel = () => ({ type: TASK_ADD_CANCEL })

export const taskAddSave = (taskName, addAnotherTask, laneId) =>
  ({
    type: TASK_ADD_SAVE,
    payload: {
      taskName,
      addAnotherTask,
      laneId,
      generatedId: uniqueId(GENERATED_TASK_ID_PREFIX)
    }
  })
export const taskAddSaveSuccess = (generatedId, addAnotherTask, savedTask) =>
  ({ type: TASK_ADD_SAVE_SUCCESS, payload: { generatedId, addAnotherTask, savedTask } })
export const taskAddSaveFailure = (payload) =>
  ({ type: TASK_ADD_SAVE_FAILURE, payload, error: true })

// Epics
export const taskAddSaveEpic = (action$, state$, { vapiClient }) =>
  action$.pipe(
    ofType(TASK_ADD_SAVE),
    mergeMap((action) =>
      vapiClient
        .addNewTask(state$.value.project.id, action.payload.taskName).pipe(
          map((ajaxResponse) => taskAddSaveSuccess(action.payload.generatedId, action.payload.addAnotherTask, ajaxResponse.response)),
          catchError(error => of(getErrorAction(error, taskAddSaveFailure, action.payload)))
        )
    )
  )

export const taskAddSaveFailureEpic = (action$, state$, { localize }) =>
action$.pipe(
  ofType(TASK_ADD_SAVE_FAILURE),
  map((action) => {
    const taskAddFailureToast = {
      type: 'error',
      message: localize(state$.value.resources, 'taskBoards.Msg_TaskAddFailure')
        .replace('{taskName}', action.payload.taskName),
      options: {
        removeOnHover: true
      }
    }
    return actions.add(taskAddFailureToast)
  })
)

// Reducer
const taskAddStartReducer = (state) => ({ ...state, isAdding: true })
const taskAddCancelReducer = (state) => ({ ...state, isAdding: false })
const taskAddSaveReducer = (state, { addAnotherTask }) => ({ ...state, isAdding: addAnotherTask })

const reducerHandlerMapping = {
  [TASK_ADD_START]: taskAddStartReducer,
  [TASK_ADD_CANCEL]: taskAddCancelReducer,
  [TASK_ADD_SAVE]: taskAddSaveReducer
}

const addTaskInitialState = { isAdding: false }
export const addTaskReducer = createReducer(addTaskInitialState, reducerHandlerMapping)

export default addTaskReducer



// WEBPACK FOOTER //
// ./src/store/addTask.js